import Column from '@components/Column';
import Image from '@components/Image';
import Row from '@components/Row';
import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import { InquiryCommentRow } from '@models/inquiry';
import dayjs from 'dayjs';

import CounselorIcon from './CounselorIcon';

interface Props {
    comment: InquiryCommentRow;
}

function InquiryComment({ comment }:Props) {
    const {
        content, authorType, createdAt, fileUrls,
    } = comment;
    const isMine = authorType === 'CUSTOMER';
    return (
        <Container fullWidth spacing={14}
            align='flex-start'>
            {(!isMine) && (<CounselorIcon/>)}
            <Column fullWidth>
                <Content color={colors.gray6}
                    dangerouslySetInnerHTML={{ __html: content }}
                    as='div' />
                {(fileUrls && fileUrls.length !== 0) && (
                    <Images>
                        {fileUrls.map((fileUrl) => (
                            <Image src={fileUrl}
                                key={fileUrl}/>
                        ))}
                    </Images>
                )}
                <DateRow justify='flex-end' fullWidth>
                    <Text color={colors.gray6}>
                        {dayjs(createdAt).format('YYYY.MM.DD HH:mm')}
                    </Text>
                </DateRow>
            </Column>
        </Container>
    );
}

const Content = styled(Text)`
    white-space: pre-wrap;
    img {
        max-width: 100%;
    }
`;

const DateRow = styled(Row)`
    margin-top: 24px;
`;

const Container = styled(Row)`
    border-bottom: 1px dashed var(--color-gray3);
    padding: 24px 20px;


    &:nth-of-type(2n + 1) {
        background-color: var(--color-gray1);
    }

    &:nth-last-of-type(1) {
        border-bottom: none;
    }
`;

const Images = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-top: 12px;
    img {
        width: 100%;
    }
`;

export default InquiryComment;
